export const filterItems = {
    high: [
        'transcript_ablation',
        'splice_acceptor_variant',
        'splice_donor_variant',
        'stop_gained',
        'frameshift_variant',
        'stop_lost',
        'start_lost',
        'transcript_amplification',
    ],
    moderate: [
        'inframe_insertion',
        'inframe_deletion',
        'missense_variant',
        'protein_altering_variant',
    ],
    low: [
        'splice_region_variant',
        'incomplete_terminal_codon_variant',
        'start_retained_variant',
        'stop_retained_variant',
    ],
    modifier: [
        'coding_sequence_variant',
        'mature_miRNA_variant',
        '5_prime_UTR_variant',
        '3_prime_UTR_variant',
        'non_coding_transcript_exon_variant',
        'intron_variant',
        'NMD_transcript_variant',
        'non_coding_transcript_variant',
        'upstream_gene_variant',
        'downstream_gene_variant',
        'TFBS_ablation',
        'TFBS_amplification',
        'TF_binding_site_variant',
        'regulatory_region_ablation',
        'regulatory_region_amplification',
        'feature_elongation',
        'regulatory_region_variant',
        'feature_truncation',
        'intergenic_variant',
    ],
}

export const filterItemsValues = [
    'transcript_ablation',
    'splice_acceptor_variant',
    'splice_donor_variant',
    'stop_gained',
    'frameshift_variant',
    'stop_lost',
    'start_lost',
    'transcript_amplification',
    'inframe_insertion',
    'inframe_deletion',
    'missense_variant',
    'protein_altering_variant',
    'splice_region_variant',
    'incomplete_terminal_codon_variant',
    'start_retained_variant',
    'stop_retained_variant',
    'coding_sequence_variant',
    'mature_miRNA_variant',
    '5_prime_UTR_variant',
    '3_prime_UTR_variant',
    'non_coding_transcript_exon_variant',
    'intron_variant',
    'NMD_transcript_variant',
    'non_coding_transcript_variant',
    'upstream_gene_variant',
    'downstream_gene_variant',
    'TFBS_ablation',
    'TFBS_amplification',
    'TF_binding_site_variant',
    'regulatory_region_ablation',
    'regulatory_region_amplification',
    'feature_elongation',
    'regulatory_region_variant',
    'feature_truncation',
    'intergenic_variant',
    undefined,
    null,
]

export const getVEPCategory = (consequence: string) => {
    let matchedKey = ''
    for (const [key, value] of Object.entries(filterItems)) {
        if (value.includes(consequence)) {
            matchedKey = key
        }
    }

    return matchedKey
}

export const getVEPCategoryImportance = (consequence: string) => {
    if(consequence.includes(',')) {
        const consequences = consequence.split(',')
        return Math.min(...consequences.map(consequence => getVEPCategoryImportanceInternal(consequence)))
    }
    return getVEPCategoryImportanceInternal(consequence)
}

const getVEPCategoryImportanceInternal = (consequence: string): number => {
    const category = getVEPCategory(consequence)
    switch (category) {
    case 'high':
        return 1
    case 'moderate':
        return 2
    case 'low':
        return 3
    default:
        return 4
    }
}
